module.exports = __webpack_public_path__ + "img/image-page.e3634a3e.png";